import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuardService} from '@Services/auth';
import {AccueilComponent} from './accueil/accueil.component';
import {EditStepperComponent} from './dossier/edit-stepper/edit-stepper.component';
import {PermissionDeniedComponent} from './common/components/permission-denied/permission-denied.component';
import {ForbiddenGuard} from './common/guards/forbidden.guard';
import {ConsultationComponent} from './dossier/consultation/consultation.component';
import {ListDossiersComponent} from './dossier/list-dossiers/list-dossiers.component';
import {AideComponent} from './aide/aide.component';
import {ConfigNotifComponent} from "app/dar/common/config-notif/config-notif.component";

const appRoutes: Routes = [
  {
    path: '',
    children: [
      {path: '', component: AccueilComponent},
      {path: 'mes-demandes', component: ListDossiersComponent},
      {path: 'edit-etapes', component: EditStepperComponent}, // TODO voir pour accéder au dossier directement http://ntld-domain/dar/edit-etapes;id=6dcefeec-fe05-4380-88bc-1a19991f73c6
      {path: 'consultation', component: ConsultationComponent},
      {path: 'gestion', loadChildren: () => import('./gestion/gestion.module').then(m => m.GestionModule)},
      {path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)},
      {path: 'notification', component: ConfigNotifComponent},
      {path: 'aide', component: AideComponent},
    ]
  },

  {path: '**', component: AccueilComponent, canActivate: [AuthGuardService]},
  {
    path: 'forbidden', component: PermissionDeniedComponent, canActivate: [ForbiddenGuard], runGuardsAndResolvers: 'always'
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {
}
